import { Typography } from 'antd';

const { Title, Paragraph } = Typography;

export default function List() {
    return (
        <>
            <Title level={4}>List:</Title>
            <Paragraph>List all registered apps.</Paragraph>
            <Typography>
                <code>modelpark ls</code>
            </Typography>
        </>
    );
}
